import {
  ConditionalRecommendation,
  GetRecommendationByIdApiResponse,
} from '@/api'

export const makeRecommendationAnalyticsPayload = (
  recommendation: ConditionalRecommendation,
) => {
  const sortedProducts = recommendation.recommendation?.recommendationProducts?.sort(
    (a, b) => a.order - b.order,
  )
  const shortenedProducts = sortedProducts.map((product) => ({
    carrierName: product.carrierData?.name,
    price: product.grossPrice,
  }))

  return {
    recommendationId: recommendation.id,
    categoryId: recommendation.recommendation?.categoryId,
    products: shortenedProducts,
  }
}

export const makeBoughtProductAnalyticsPayload = (
  recommendationProductId: string,
  recommendation:
    | ConditionalRecommendation['recommendation']
    | GetRecommendationByIdApiResponse,
) => {
  const boughtProduct = recommendation?.recommendationProducts?.find(
    (product) => product.recommendationProductId === recommendationProductId,
  )

  return {
    carrierName: boughtProduct?.carrierData?.name,
    price: boughtProduct?.grossPrice,
  }
}
